module.exports = __webpack_public_path__ + "img/enquiry-fab-en.06544dc.svg";